import React from "react";
import ReactJson from "react-json-view";

export const JsonTextArea = ({ src = {} }) => {
    return (
        <div className="json-text-area-container">
            <ReactJson
                src={src}
                theme="rjv-default"
                name={null}
                displayDataTypes={false}
                displayObjectSize={false}
                enableClipboard={false}
                collapsed={false}
                style={{
                    fontFamily: "Open Sans",
                    fontSize: "12px",
                    height: "200px",
                    overflow: "auto"
                }}
            />
        </div>
    );
};

export default JsonTextArea;
